import React from 'react';
import PropTypes from 'prop-types';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';
import { getBudgetLandscapeTableView } from './budget-landscape-table';

class BudgetEditorWithLandscapeInternal extends React.PureComponent {
  constructor(props) {
    super(props);

    const {
      serverContext,
      scope,
      budgetAmount,
      i18n,
      activityLogger,
      isSharedBudget,
      budgetId,
    } = this.props;

    this.budgetLandscapeTable = React.lazy(() => getBudgetLandscapeTableView({
      serverContext,
      scope,
      currentBudgetAmount: budgetAmount,
      i18n,
      activityLogger,
      isSharedBudget,
      budgetId,
    }).then((tableView) => {
      this.props.setTableView(tableView);

      return {
        default: () => (
          <div className="landscape-table">
            <BackboneInstanceWrapper
              instance={tableView}
            />
          </div>),
      };
    }));
  }

  render() {
    const BudgetLandscapeTable = this.budgetLandscapeTable;

    return (
      <React.Suspense fallback={<div>{this.props.i18n.getString(_TL_('Loading...'))}</div>}>
        <BudgetLandscapeTable />
      </React.Suspense>);
  }
}

BudgetEditorWithLandscapeInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  serverContext: PropTypes.shape({
    BudgetRange: PropTypes.shape({}).isRequired,
    CurrentAccount: PropTypes.shape({}).isRequired,
  }).isRequired,
  budgetAmount: PropTypes.number,
  setTableView: PropTypes.func.isRequired,
  activityLogger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }).isRequired,
  isSharedBudget: PropTypes.bool,
  budgetId: PropTypes.number,
};

BudgetEditorWithLandscapeInternal.defaultProps = {
  budgetAmount: null,
  isSharedBudget: false,
  budgetId: 0,
};

const Wrapped = withServerContext(BudgetEditorWithLandscapeInternal);

export { Wrapped as BudgetEditorWithLandscape };
